<div class="w-full -mt-6 h-full relative">
    <div class="z-[100] h-[70px] sticky header-s top-[113px] -ml-4 px-4 bg-white flex items-center"
        style="width: calc(100% + 32px); box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.2)">
        <p class="text-xl text-center font-medium m-0 global-text tracking-wider">
            <span class="highlight-icd">ICD</span> 
            <span class="highlight-xanh-y-te"> Smart Search</span>
        </p>
        <div #boxSearch id="box-search" class="bar ml-[20px] bg-white flex items-center relative">
            <div class="w-[50px] h-full flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" class="translate-x-[2px]" height="24" fill="#5F6368">
                    <path
                        d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                </svg>
            </div>
            <input autocomplete="off" #searchInput [(ngModel)]="searchQuery" (input)="handleInputChange()"
                (keydown)="handleKeyDown($event)" id="searchGlobal" class="searchbar"
                placeholder="Nhập bất kì từ khóa nào để tìm kiếm" type="text" title="Search" />

            <ng-container *ngIf="isLoadingSearch; else info">
                <div class="flex items-center justify-center">
                    <div class="spinner-container">
                        <div class="spinner_search"></div>
                    </div>
                </div>
            </ng-container>
            <ng-template #info>
                <div (click)="handleDelInput()"
                    [ngClass]="{ hidden: searchQuery.length <= 0, flex: searchQuery.length > 0 }"
                    class="w-[50px] h-full items-center justify-center cursor-pointer">
                    <svg focusable="false" width="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path fill="#70757a"
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z">
                        </path>
                    </svg>
                </div>
            </ng-template>
            <div #recommendBox id="recommend-box" class="recommend-box hidden w-full bg-white absolute top-[45px]">
                <ul class="w-full pt-2 border-t list-none p-0">
                    <li *ngFor="let item of searchRecommend; let i = index" class="h-[30px] rec-item"
                        [class.activate]="i === selectedIndex" (click)="onSearchItemClick(item)">
                        <div class="w-full h-full flex items-center">
                            <div class="w-[50px] h-full flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" class="translate-x-[2px]" height="24"
                                    fill="#5F6368">
                                    <path
                                        d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                                </svg>
                            </div>
                            {{ item }}
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="h-[45px] mr-4">
            <mat-form-field appearance="outline">
                <mat-label>Hiển thị</mat-label>
                <mat-select [formControl]="displayMode">
                    <mat-option value="tree">Cây</mat-option>
                    <mat-option value="flat">Phẳng</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="h-[45px]">
            <mat-form-field appearance="outline">
                <mat-label>Phiên bản</mat-label>
                <mat-select [formControl]="appFilter">
                    <mat-option value="ICD-10">ICD 10</mat-option>
                    <mat-option value="ICD-9">ICD 9</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
<!--        <div class="flex flex-row gap-3">-->
<!--            <button class=" border flex items-center justify-center rounded-[25px] w-[80px] h-[30px]" [ngClass]="{-->
<!--                'hover:bg-slate-300': appFilter.value !== '',-->
<!--                'bg-slate-300': appFilter.value === ''-->
<!--            }" (click)="setActiveButton('')">-->
<!--            Tất cả-->
<!--        </button>-->

<!--        <button class=" border flex items-center justify-center rounded-[25px] w-[80px] h-[30px]" [ngClass]="{-->
<!--                'hover:bg-slate-300': appFilter.value !== 'ICD-10',-->
<!--                'bg-slate-300': appFilter.value === 'ICD-10'-->
<!--            }" (click)="setActiveButton('ICD-10')">-->
<!--            ICD-10-->
<!--        </button>-->

<!--        <button class="border flex items-center justify-center rounded-[25px] w-[80px] h-[30px]" [ngClass]="{-->
<!--                'hover:bg-slate-300': appFilter.value !== 'ICD-9',-->
<!--                'bg-slate-300': appFilter.value === 'ICD-9'-->
<!--            }" (click)="setActiveButton('ICD-9')">-->
<!--            ICD-9-->
<!--        </button>-->
<!--        </div>-->
    </div>
    <p *ngIf="!isLoading && searchResult && searchResult.length > 0" class="mt-3 mb-0">
        Khoảng {{ searchResult.length }} kết quả ({{ responseTime }} giây)
    </p>
    <p *ngIf="!isLoading && searchResult && searchResult.length <= 0" class="mt-3 text-[red] mb-0">
        Không tìm thấy kết quả nào!
    </p>
    <div id="search-result" class="flex flex-row gap-3">
        <div #searchBox *ngIf="!isLoading && displayMode.value === 'flat'"  id="result-box" class="result-box w-full mt-1">
            <ul class="w-full pt-2 border-t list-none px-0">
                <li *ngFor="let item of searchResult; let i = index;" class="mb-3">
                    <div class="w-full rounded-2xl bg-white px-3 pt-3 shadow-md h-full flex flex-col">
                        <div (click)="getData(item)"
                            class="flex w-fit  flex-row items-center cursor-pointer mb-0.5 h-s">
                            <div class="text-[10px] font-semibold rounded-[10px] p-1 w-[45px] h-[45px] flex items-center justify-center text-white"
                                [ngStyle]="{ 'background-color': item.color }">
                                {{ item.app_name }}
                            </div>

                            <div class="flex flex-col ml-3">
                                <p class="m-0">{{ item.model }}</p>
                                <p class="m-0 text-[#4d5156] text-[12px]">
                                    {{ baseUrl
                                    }}<span *ngFor="let tx of item.split_href"> › {{ tx }}</span>
                                </p>
                            </div>
                        </div>
                        <p (click)="getData(item)"
                            class="text-lg name-s w-fit cursor-pointer text-[#1a0dab] !mb-0 hover:underline">
                            {{ item.name_vn }}
                            – {{ item.name }}
                        </p>
                        <p class="text-[#4d5156] content-x m-0" [innerHTML]="item.content"></p>
                        <!-- <p class="text-gray-600 font-medium"><span (click)="onLike(i)"
                                class="like mr-2 cursor-pointer"><svg width="20" height="20" viewBox="0 0 24 24"
                                    [attr.fill]="eve[i]===1 ? '#1a0dab' : 'none'" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7.47998 18.35L10.58 20.75C10.98 21.15 11.88 21.35 12.48 21.35H16.28C17.48 21.35 18.78 20.45 19.08 19.25L21.48 11.95C21.98 10.55 21.08 9.34997 19.58 9.34997H15.58C14.98 9.34997 14.48 8.84997 14.58 8.14997L15.08 4.94997C15.28 4.04997 14.68 3.04997 13.78 2.74997C12.98 2.44997 11.98 2.84997 11.58 3.44997L7.47998 9.54997"
                                        [attr.stroke]="eve[i]===1 ? '#1a0dab' : '#292D32'" stroke-width="1.5"
                                        stroke-miterlimit="10" />
                                    <path
                                        d="M2.38 18.35V8.55002C2.38 7.15002 2.98 6.65002 4.38 6.65002H5.38C6.78 6.65002 7.38 7.15002 7.38 8.55002V18.35C7.38 19.75 6.78 20.25 5.38 20.25H4.38C2.98 20.25 2.38 19.75 2.38 18.35Z"
                                        [attr.stroke]="eve[i]===1 ? '#1a0dab' : '#292D32'" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span> <span (click)="onUnLike(i)" class="cursor-pointer"><svg width="20" height="20"
                                    viewBox="0 0 24 24" [attr.fill]="eve[i]===0 ? 'red' : 'none'"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M16.52 5.65002L13.42 3.25002C13.02 2.85002 12.12 2.65002 11.52 2.65002H7.71998C6.51998 2.65002 5.21998 3.55002 4.91998 4.75002L2.51998 12.05C2.01998 13.45 2.91998 14.65 4.41998 14.65H8.41998C9.01998 14.65 9.51998 15.15 9.41998 15.85L8.91998 19.05C8.71998 19.95 9.31998 20.95 10.22 21.25C11.02 21.55 12.02 21.15 12.42 20.55L16.52 14.45"
                                        [attr.stroke]="eve[i]===0 ? 'red' : '#292D32'" stroke-width="1.5"
                                        stroke-miterlimit="10" />
                                    <path
                                        d="M21.62 5.65V15.45C21.62 16.85 21.02 17.35 19.62 17.35H18.62C17.22 17.35 16.62 16.85 16.62 15.45V5.65C16.62 4.25 17.22 3.75 18.62 3.75H19.62C21.02 3.75 21.62 4.25 21.62 5.65Z"
                                        [attr.stroke]="eve[i]===0 ? 'red' : '#292D32'" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                        </p> -->
                    </div>
                </li>
            </ul>
        </div>
        <div *ngIf="!isLoading && displayMode.value === 'tree'" class="mt-1 w-full">
            <mat-tree #tree [dataSource]="searchTreeResult" [treeControl]="treeControl" class="tree-view">
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                        <span class="text-lg cursor-pointer hover:text-[#1a0dab] hover:underline" (click)="getData(node)">
                            <b>{{node.code}}: </b>{{ node.name_vn }}<br>
                            <span class="text-sm"> {{ node.name }} </span>
                        </span>
                </mat-tree-node>
                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                    <div class="mat-tree-node !min-h-[36px] max-h-[42px]">
                        <button mat-icon-button matTreeNodeToggle
                                [attr.aria-label]="'Toggle ' + node.name">
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                            </mat-icon>
                        </button>
                        <span class="text-lg cursor-pointer hover:text-[#1a0dab] hover:underline space-x-2" (click)="getData(node)">
                            <b>{{node.code}}: </b> {{node.name_vn}}
                        </span>
                    </div>
                    <div [class.tree-view-invisible]="!treeControl.isExpanded(node)"
                         role="group">
                        <span class="text-sm">{{node.name}}</span>
                        <ng-container matTreeNodeOutlet></ng-container>
                    </div>
                </mat-nested-tree-node>
            </mat-tree>
        </div>
        <div>
            <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                <div class="offcanvas-header">
                    <div id="offcanvasRightLabel">
                        <h5>ICD Smart Search | icd.whiteneuron.com</h5>
                    </div>
                    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div class="offcanvas-body">
                    <div [innerHTML]="getSafeHtml()"></div>
                </div>
            </div>
            <!-- <div class="content-rs bg-white p-4 sticky top-[233px] shadow-md rounded-[10px] overflow-y-auto" style="
                    width: calc(100vw/4);
                    height: calc(100vh - 240px);
                " *ngIf="dataHtml">
            </div> -->
        </div>
    </div>
</div>
<div *ngIf="isLoading || !searchResult" class="mt-[250px] flex items-center justify-center">
    <div class="spinner-container">
        <div class="spinner"></div>
    </div>
</div>